__turbopack_context__.v({
  "sticky-bar": "bQBd4G_sticky-bar",
  "sticky-bar__body": "bQBd4G_sticky-bar__body",
  "sticky-bar__button": "bQBd4G_sticky-bar__button",
  "sticky-bar__copy": "bQBd4G_sticky-bar__copy",
  "sticky-bar__heading": "bQBd4G_sticky-bar__heading",
  "sticky-bar__image": "bQBd4G_sticky-bar__image",
  "sticky-bar__inner": "bQBd4G_sticky-bar__inner",
  "sticky-bar__picture": "bQBd4G_sticky-bar__picture",
  "sticky-bg": "bQBd4G_sticky-bg",
});
